module.exports = __webpack_public_path__ + "static/media/ic_edit_selected.af4fb981.svg";